import type { Path, To } from 'react-router';

const AI_PREFIX = [
  'are',
  'can',
  'could',
  'did',
  'does',
  'have',
  'has',
  'how',
  'is',
  'should',
  'was',
  'what',
  'when',
  'where',
  'which',
  'who',
  'whom',
  'whose',
  'why',
  'will',
  'would',
];

// if query is 3 words or more and
// starts with question word (prefix to handle "whats the wifi password") or ends with ?
// keep lib/slab/ai/ask.ex in sync
export const isAiQuestion = (query: string) => {
  const lowercaseWords = query.toLowerCase().trim();
  if (lowercaseWords.split(/\s+/, 3).length < 3) return false;
  const sentences = lowercaseWords.split('?', 2);
  return (
    sentences.length > 1 ||
    AI_PREFIX.some((word) => sentences[0]?.startsWith(word))
  );
};

export const getAiAskLocation = (location?: Partial<Path>): To | undefined => {
  const search = new URLSearchParams(location?.search);
  search.set('mode', 'ask');

  return location
    ? {
        ...location,
        search: `?${search}`,
      }
    : location;
};
